import { TrackingEvent } from 'client/tracking/event';
import { CommonMap } from 'client/tracking/maps/common';
import { TrackingConstant } from 'client/tracking/constant';

const map = {
  mpg_change_zip: TrackingEvent.actionCompleted(
    TrackingConstant.ACTION_TOOL_SELECT,
    TrackingConstant.MPG_ZIP_CODE_ENTRY
  ),
  mpg_change_miles: TrackingEvent.actionCompleted(
    TrackingConstant.ACTION_TOOL_SELECT,
    TrackingConstant.MPG_MILES_PER_YEAR_ENTRY
  ),
  mpg_change_daily_commute: TrackingEvent.actionCompleted(
    TrackingConstant.ACTION_TOOL_SELECT,
    TrackingConstant.MPG_DAILY_COMMUTE_ENTRY
  ),
  mpg_change_percents: TrackingEvent.actionCompleted(
    TrackingConstant.ACTION_TOOL_SELECT,
    TrackingConstant.MPG_CITY_HIGHWAY_ENTRY
  ),
  mpg_different_year_select: TrackingEvent.actionStart(
    TrackingConstant.ACTION_MMY_SELECT,
    TrackingConstant.YEAR_SELECT
  ),
  mpg_different_make_select: TrackingEvent.actionProgress(
    TrackingConstant.ACTION_MMY_SELECT,
    TrackingConstant.MAKE_SELECT
  ),
  mpg_different_model_select: TrackingEvent.actionProgress(
    TrackingConstant.ACTION_MMY_SELECT,
    TrackingConstant.MODEL_SELECT
  ),
  mpg_different_trim_select: TrackingEvent.actionProgress(
    TrackingConstant.ACTION_MMY_SELECT,
    TrackingConstant.TRIM_SELECT
  ),
  mpg_different_submit: TrackingEvent.actionEnd(TrackingConstant.ACTION_MMY_SELECT, TrackingConstant.SUBMIT_MMYT),
  mpg_all_for_sale: TrackingEvent.actionCompleted(
    TrackingConstant.ACTION_VIEW_CONTENT,
    TrackingConstant.VIEW_MORE_INVENTORY
  ),
};

export const TrackingMap = {
  ...CommonMap,
  ...map,
};
